import axios from "axios";
import { workwiseServices } from "../Workw-Api/api";
import { isLocalGridRoute } from "./localGrids";

const konn = "https://grid.workw.com";
const templateBaseURL = "https://pad.workw.com/padApi/v2";
const adminBaseURL = "https://pad.workw.com/padApi/v1";
// const konn = "http://localhost:8080";


export const loadServerData = async (id) => {
    try {
        const response = await axios.get(`${konn}/api/${id}`);
        return response.data?.[0];
    } catch (error) {
        console.error(`Error loading server data for ID: ${id}`, error);
        return null;
    }
};

/**
 * Local (offline-created) grids have no server counterpart, so every write would
 * 404 or create phantom rows. Each write below bails on a local route: the
 * spreadsheet still updates in memory, only the network goes quiet, and the
 * container persists to localStorage instead.
 */
export const updateSheet = async (id, data) => {
    if (isLocalGridRoute()) return;
    try {
        await axios.post(
            `${konn}/api/update`,
            {
                spreadsheetID: id,
                spreadsheetData: data,
            }
        );
    } catch (e) {
        console.error(e);
    }
};
export const deleteSheet = async (id, data, setSavingData) => {
    if (isLocalGridRoute()) return;
    try {
        await axios.post(
            `${konn}/api/sheet/delete`,
            {
                spreadsheetID: id,
                sheetName: data.sheetName,
            }
        );
        workwiseServices.saveDocumentlastUpdate(id, setSavingData, data.sheets);
    } catch (e) {
        console.error(e);
    }
};
export const renameSheet = async (id, data, setSavingData) => {
    if (isLocalGridRoute()) return;
    try {
        await axios.post(
            `${konn}/api/sheet/rename`,
            {
                spreadsheetID: id,
                sheetName: data.oldName,
                newSheetName: data.newName,
            }
        );
        workwiseServices.saveDocumentlastUpdate(id, setSavingData, data.sheets);
    } catch (e) {
        console.error(e);
    }
};
export const loadSpreadsheetData = async (id) => {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const milegridURL = url.searchParams.get("gridname");

    try {
        document.getElementById("milegrid-url").innerHTML = milegridURL;
        const response = await axios.get(
            `${konn}/api/${id}`
        );
        let filteredSheetData;
        const getSheetData = response.data?.[0]?.spreadsheetData;
        if (getSheetData) {
            filteredSheetData = getSheetData.filter(word => Object.keys(word).length > 0);
            return filteredSheetData;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};
/**
 * Bulk write used by .grid import and by syncing a local grid.
 *
 * Rethrows so the caller can tell the user the save never reached the server —
 * the import still loads the data locally, which would otherwise look like it
 * had succeeded.
 */
export const saveImportDataToDb = async (data) => {
    try {
        await axios.post(`${konn}/api/import/internal`, { ...data });
    }
    catch (error) {
        console.log(error);
        throw error;
    }
}
export const syncDocument = async ({ spreadsheetID, spreadsheetData = [], Comments = [] }) => {
    const response = await axios.post(`${konn}/api/sync`, {
        spreadsheetID,
        spreadsheetData: Array.isArray(spreadsheetData) ? spreadsheetData : [],
        Comments: Array.isArray(Comments) ? Comments : [],
    });
    return response.data;
};

export const verifyExternal = async (id) => {
    const response = await axios.get(`${konn}/api/external/verify/${id}`);
    return response.data;
};
export const updateDocumentPrivacy = async (data) => {
    const response = await axios.post(`${konn}/api/external/privacyUpdate`, data);
    return response.data;
};

export const updateAllSheets = async (id, data, isTemplate = false) => {
    if (isLocalGridRoute()) return;
    if (isTemplate) {
        await templateService.updateTemplate({ templateId: id, data: { milepadData: JSON.stringify(data), docType: 'milegrid' }, dispatch: () => { } });
    } else {
        try {
            await axios.post(
                `${konn}/api/updateAllSheets`,
                {
                    spreadsheetID: id,
                    spreadSheets: data,
                }
            );
        } catch (e) {
            console.error(e);
        }
    }
};

export const templateService = {
    async fetchTemplateById(templateId) {
        return axios.get(`${templateBaseURL}/template/getById/${templateId}`);
    },
    async getAllTemplates(params = {}) {
        try {
            // Optionally pass query params (e.g., pagination or filters) via params
            const defaultParams = { docType: 'milegrid', ...params };
            const res = await axios.get(`${templateBaseURL}/template/getAllTemplates`, { params: defaultParams });
            return res;
        } catch (e) {
            console.error('Error fetching templates:', e);
            throw e;
        }
    },
    async updateTemplate(params) {
        const { templateId, data, dispatch } = params;
        try {
            const res = await axios.patch(`${templateBaseURL}/template/update/${templateId}`, data);
            // Assuming similar update logic, but adjust if needed
            workwiseServices.saveDocumentlastUpdate(templateId, dispatch, res.data);
            return res;
        } catch (e) {
            console.error('Error updating template:', e);
        }
    },

    async createTemplate(data) {
        try {
            const res = await axios.post(`${templateBaseURL}/template/create`, data);
            return res;
        } catch (e) {
            console.error('Error creating template:', e);
            throw e;
        }
    },
    deleteTemplate: async (templateId) => {
        return axios.delete(`${templateBaseURL}/api/template/delete/${templateId}`);
    },
};

export const adminService = {
    async getAllAdmins(params = {}) {
        try {
            const res = await axios.get(`${adminBaseURL}/getAll`, { params });
            return res;
        } catch (e) {
            console.error('Error fetching admin templates:', e);
            throw e;
        }
    },
};